import React, { useEffect, useState } from "react";
import "./App.css";
import Main from "./containers/Main";
import logUserDetails from "./logUserDetails";
import { greeting, socialMediaLinks } from "./portfolio";

function App() {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Get the current pathname from the URL
    const hostname = window.location.hostname;
    const pathname = window.location.pathname.toLowerCase();

    if (pathname === "/resume" || pathname === "/resume/") {
      logUserDetails(true);
      window.location.href = greeting.resumeLink;
      return;
    }

    // Check if the URL's hostname matches either of the specified values
    if (
      hostname === "harshraj-dev.web.app" ||
      hostname === "harshraj-dev.firebaseapp.com"
    ) {
      // Redirect to 'harshraj.dev'
      window.location.href = "https://harshraj.dev";
      return;
    }

    // if (window.location.pathname === '/projects/InterviewX' || window.location.pathname === '/projects/InterviewX/') {
    //   // Redirect to the new URL
    //   window.location.replace('/projects/InterviewX.html');
    //   return;
    // }

    // if (window.location.pathname === '/projects/InterviewX.html') {
    //   logUserDetails();
    // }

    // Build dynamic redirect map
    const redirects = {};
    Object.entries(socialMediaLinks).forEach(([key, value]) => {
      // Only add if it's a valid URL
      if (typeof value === "string" && value.startsWith("http")) {
        redirects[`/${key}`] = value;
      }
    });

    if (redirects[pathname]) {
      window.location.href = redirects[pathname];
      return;
    }

    // If no redirects, set shouldRender to true
    setShouldRender(true);

    // Log user details if not redirecting
    logUserDetails();

  }, []);

  if (!shouldRender) return null; // Or show a loader if preferred

  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
